import React from 'react';
import profile from '../../images/splash/user.png';
import { useState,useEffect } from 'react';
import axios from 'axios';
import { var_api } from '../constant';
import Swal from 'sweetalert2';
import { useHistory } from 'react-router-dom';
import Select from 'react-select';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import Layout from '../NewHeader/Layout';
import './slot_creation.css';
import slotimg from "../../images/free.png"
import Pagination from 'react-js-pagination';


const CreateBlockingPublicHoliday = () => {
  const history = useHistory();
  const [show, setShow]  = useState(false);
  const [tables, setTables] = useState([]);
  const [shops, setShops] = useState([]);
  const [blockedSlots, setBlockedSlots] = useState([]);

  
  const [selectedShop, setSelectedShop] = useState(null);
  const [ searchQuery,setSearchQuery] = useState('');
  const [selectedItemCode, setSelectedItemCode] = useState(null);
  const [ isEdit,setIsEdit ] = useState(false);
  
  const [ isCreate,setCreate ] = useState(false);

  const [ loading, setLoading ] = useState(false);
  const [ postloading,setPostLoading ] = useState(false);
  const ItemCodeOptions = [

    { value: 'Chef', label: 'Chef' },
    { value: 'Captain', label: 'Captain' },
    { value: 'Waiter', label: 'Waiter' },
    // Add more options as needed
  ];
  
  const [DeleteId, setEmployeeD] = useState({});
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [selectedSuppliers, setSelectedSuppliers] = useState(null);

  const [formData, setFormData] = useState({
    shop_id:null,
    blocked_date: "", 
    slot_id: null, 
    remarks: null,
    is_active:null
});
const [updateformData, setUpdateFormData] = useState({
  shop_id:null,
  blocked_date: "", 
  slot_id: null, 
  remarks: null,
  is_active:null,
  slot_name:null


});

console.log(formData)

//change the role
  const handleCodeSelectChange = (selectedItem) => {
    console.log("selectedItem",selectedItem)
    const role = selectedItem.value
    setFormData({ ...formData, e_role: role });
  };

  const handleSupplierSelectChange = (selectedOption) => {
    setSelectedSupplier(selectedOption);
    setFormData((formData) => ({
      ...formData,
      slot_id: selectedOption.value, // Update slot_id with the selected value
    }));
  };

  const handleSupplierSelectChanges = (selectedOption) => {
    setSelectedSuppliers(selectedOption);
    console.log("sel", selectedOption);
    setUpdateFormData((prevFormData) => ({
      ...prevFormData,
      slot_id: selectedOption.value,
      slot_name: selectedOption.label, // Ensure slot_name is updated
    }));
  };

    useEffect(() => {
        fetchTables();
        fetchBlockedSlots();
      }, []);


      const fetchTables = async () => {
        setLoading(true);
        try {
          const token=localStorage.getItem('Token');
          const shop_id=localStorage.getItem('ShopId');

           const response = await axios.get(`${var_api}slot-master/get/${shop_id}`,{
            headers:{
              Authorization: `${token}`, // Pass user token
            }
           });
           setLoading(false);
           console.log("response",response)
          const user =response.data;
          setTables(user);
          
        } catch (error) {
          setLoading(false);
          if (error.response && error.response.status === 401) {
            localStorage.removeItem('Token'); // Clear the invalid token
            history.push('/')// Redirect to the Sign-In page
          } else {
            console.error("Error updating data:", error);
          }
        }
      };



      const fetchBlockedSlots = async () => {
        setLoading(true);
        try {
          const token=localStorage.getItem('Token');
          const shop_id=localStorage.getItem('ShopId');

           const response = await axios.get(`${var_api}block-slot-master/get-details/${shop_id}`,{
            headers:{
              Authorization: `${token}`, // Pass user token
            }
           });
           setLoading(false);
           console.log("response",response)
          const user =response.data;
          setBlockedSlots(user);
          
        } catch (error) {
          setLoading(false);
          if (error.response && error.response.status === 401) {
            localStorage.removeItem('Token'); // Clear the invalid token
            history.push('/')// Redirect to the Sign-In page
          } else {
            console.error("Error updating data:", error);
          }
        }
      };


      const handleInputChange = (e) => {
        const { name, value } = e.target;

          setFormData((prevFormData) => ({
            ...prevFormData,
            [name]: value,
          }));
        }
      
  // Function to capitalize the first letter of a string
  const capitalize = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
   };
  

      //post the form data
      const Submit = (e) => {
        e.preventDefault();
        const shopId=localStorage.getItem('ShopId');
        // Prepare the payload
        const payload = {
          shop_id: shopId, // Replace with the appropriate shop_id value
          blocked_date: convertDateToInputFormat(formData.blocked_date),
          slot_id: formData.slot_id,
          remarks: formData.remarks, // Default value for active status
          created_at: new Date().toISOString(), // Current timestamp
          updated_at: new Date().toISOString(), // Current timestamp
        };
      
        const token = localStorage.getItem('Token');
      
        axios
          .post(`${var_api}block-slot-master/post`, payload, {
            headers: {
              Authorization: `${token}`,
              "Content-Type": "application/json",
            },
          })
          .then((response) => {
              Swal.fire("Success", "Supplier created successfully!", "success");
              
              fetchBlockedSlots(); // Refresh the table data
              setFormData({});
              setCreate(false);
          
          })
          .catch((error) => {
            if (error.response && error.response.status === 401) {
              localStorage.removeItem('Token'); // Clear the invalid token
              history.push('/')// Redirect to the Sign-In page
            } else {
              console.error("Error updating data:", error);
            }
            Swal.fire(
              "Error",
              `${error.response?.data?.error || "Unexpected error occurred"}`,
              "error"
            );
          });
      };



     //delete method for remove UOM
   const handleDeleteEmployeee = (id) => {
    setShow(true);
    setEmployeeD({id})
    }


    //delete the employeee
    const handleDelete = () => {
      const token=localStorage.getItem('Token');
      axios.delete(`${var_api}block-slot-master/delete/${DeleteId.id}`,{
        headers:{
          Authorization:`${token}`
        }
      }
      )
        .then((response) => {
          if (response.status === 200) {
            fetchBlockedSlots(); // Refresh the employee list
            setShow(false);
            Swal.fire("Success", "Blocked slot removed successfully!", "success");
          } else if (response.status === 404) {
            console.error("Employee not found");
          }
        })
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            localStorage.removeItem('Token'); // Clear the invalid token
            history.push('/')// Redirect to the Sign-In page
          } else {
            console.error("Error updating data:", error);
          }
          Swal.fire("Error", `${error.response.data.message}`, "error");
        });
      };


    //Function for open the update modal
    const handleUpdateEmployee = (data) =>{
      setIsEdit(true);
      console.log("data",data)
      setUpdateFormData({
          id:data.id,
          shop_id: data.shop_id, 
          blocked_date:convertDateToStateFormat(data.blocked_date), 
          slot_id: data.slot_id,
          remarks: data.remarks,
          slot_name:data.slot_name

      })
    }
    const handleCreateEmployee = () =>{
      setCreate(true);
    }
    //Function for update text field onchange
const handleInputUpdateChange = (e) => {
  const { name, value } = e.target;
  setUpdateFormData({ ...updateformData, [name]: value });
};


//onchange function for file 
const handleImageUpdateChange = (e) => {
  const file = e.target.files[0];
  console.log("file",file)
  setUpdateFormData({ ...updateformData, profile: file });
};





const handleUpdateSubmit = async (e) => {
  e.preventDefault();
 
  const payload = {
    shop_id: updateformData.shop_id, // Replace with the appropriate shop_id value
    blocked_date: convertDateToInputFormat(updateformData.blocked_date),
    slot_id: updateformData.slot_id,
    remarks: updateformData.remarks, // Default value for active status
    };
  try {
    const token = localStorage.getItem("Token"); // Replace with your token logic
    const response = await axios.put(`${var_api}block-slot-master/put/${updateformData.id}`, // Use the selected item's ID
      payload,
      {
        headers: {
          Authorization: token,
        },
      }
    );
    if (response.status === 200) {
      Swal.fire("success"," Blocked slot Updated Successfully!","success")

      setIsEdit(false); // Close the modal
      fetchBlockedSlots(); // Refresh the data
    }
  } catch (error) {
    Swal.fire("Error", `${error.response.data.error}`, "error");
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('Token'); // Clear the invalid token
      history.push('/')// Redirect to the Sign-In page
    } else {
      console.error("Error updating data:", error);
    }
  }
};
//update method for employee

  // const handleToggle = (isChecked, item) => {
  //   const payload = {
  //     id:item.id,
  //     shop_id: item.shop_id, 
  //     blocked_date:(item.blocked_date), 
  //     slot_id: item.slot_id,
  //     remarks: item.remarks,
  //     slot_name:item.slot_name,
  //     is_active:isChecked ? 1 : 0,
  //   };
  
  //   const token = localStorage.getItem('Token');
    
  //   axios
  //     .put(`${var_api}block-slot-master/put/${item.id}`, payload, {
  //       headers: {
  //         Authorization: `${token}`,
  //         "Content-Type": "application/json",
  //       },
  //     })
  //     .then((response) => {
  //       if (response.status === 200) {
  //         Swal.fire("Success", "Status updated successfully!", "success");
  //         fetchBlockedSlots();
  //       } else {
  //         Swal.fire("Error", "Failed to update category status!", "error");
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("Error updating category status:", error);
  //       Swal.fire("Error", `${error.response?.data?.error || "Unexpected error occurred"}`, "error");
  //     });
  // };

  const convertDateToStateFormat = (date) => {
    if (!date) return ""; // Return empty string if no date is provided
    const [day, month, year] = date.split("-");
    return `${year}-${month}-${day}`;
  };
  const convertDateToInputFormat = (date) => {
    if (!date) return ""; // Return empty string if no date is provided
    const [year, month, day] = date.split("-");
    return `${day}-${month}-${year}`;
  };
  
  const data = [
    { id: 1, date: '06-11-2024', slotName: 'Slot 1', description: 'Slot 1 Description' },
    { id: 2, date: '07-11-2024', slotName: 'Slot 2', description: 'Slot 2 Description' },
    { id: 3, date: '08-11-2024', slotName: 'Slot 3', description: 'Slot 3 Description' },
    { id: 4, date: '09-11-2024', slotName: 'Slot 4', description: 'Slot 4 Description' },
    { id: 5, date: '10-11-2024', slotName: 'Slot 5', description: 'Slot 5 Description' },
    { id: 6, date: '11-11-2024', slotName: 'Slot 6', description: 'Slot 6 Description' },
    { id: 7, date: '12-11-2024', slotName: 'Slot 7', description: 'Slot 7 Description' },
    { id: 8, date: '13-11-2024', slotName: 'Slot 8', description: 'Slot 8 Description' },
    { id: 9, date: '14-11-2024', slotName: 'Slot 9', description: 'Slot 9 Description' },
    { id: 10, date: '15-11-2024', slotName: 'Slot 10', description: 'Slot 10 Description' },
  ];
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10); // Number of items per page
  const [searchTerm, setSearchTerm] = useState('');
  
  // Filtering tables based on search term
  const filteredTables = blockedSlots.filter((item) => {
    return (
      item.slot_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.remarks.toLowerCase().includes(searchTerm.toLowerCase()) ||
      String(item.blocked_date).toLowerCase().includes(searchTerm.toLowerCase()) 
 
    );
  });
  
  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredTables.slice(indexOfFirstItem, indexOfLastItem);
  const totalItems = filteredTables.length;
  
  const handleSearchInput = (event) => {
    setSearchTerm(event.target.value);
    setCurrentPage(1); // Reset to the first page when search changes
  };
  
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };


    return(
      <>         <Layout>

      
            <div class="splitsc">
          
      <div style={{border:"none",padding:"20px",width:"100%",height:"auto",margin:"auto",borderRadius:"15px",backgroundColor:"white",boxShadow:" rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px, rgba(17, 17, 26, 0.1) 0px 24px 80px"}}>    
    {/* <Button variant='dark'className='mb-4' onClick={handleCreateEmployee}   style={{fontSize:"18px",float:"right",borderRadius:"15px"}}>Create Blocked Slot</Button>{' '}
     */}
    <div>
    <div class="row">
     <div class="col">
         <h4 className='ushe'>BLOCKING SLOT</h4>
         </div>
         <div class="col">
       <Button variant='dark'className='mb-4' onClick={handleCreateEmployee}   style={{fontSize:"14px",float:"right",borderRadius:"10px", marginLeft:"10px"}}>Create Blocking Slot</Button>{' '}
       <input class="form-control" type="Search" placeholder="Search" id="example-search-input" 
    style={{width:"230px",borderRadius:"10px",border:"1px solid black",float:"right"}} onChange={handleSearchInput}/>
       </div>
     </div>
      <div className="table-container" style={{ height:"500px", overflowX: 'auto', overflowY: 'scroll' }}>
     <table class="table table-hover small-first-col" style={{border:"none",borderColor:"grey",width:"90%",margin:"auto"}}>
  <thead>
    <tr style={{fontWeight:"bolder"}}>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">S.No</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Blocked Date</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Blocked Slot Name</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Remarks</th>
      {/* <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Status</th> */}

      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Action</th>
    </tr>
  </thead>
  {loading ? (
        <div className="loader-containeru">
      	  <div className="spinneru"></div>
        </div>
  ) : 
  <tbody class="body-half-screen">
   {currentItems && currentItems.length > 0 ? (

currentItems.map((item, index) => (
        <tr key={item.id} style={{ padding: "4px" }}>
          <th scope="row" style={{ textTransform: "capitalize", textAlign: "left" }}>{index + 1}</th>
          <td style={{ textTransform: "capitalize", textAlign: "left" }}>{item.blocked_date}</td>
          <td style={{ textTransform: "capitalize", textAlign: "left" }}>{item.slot_name}</td>
          <td style={{ textAlign: "left" }}>{item.remarks}</td>
         

          <td style={{ textAlign: "left" }}>
            <i className="bi bi-pencil-square" onClick={() => handleUpdateEmployee(item)} style={{ fontSize: "20px", color: "rgb(9, 97, 9)" }}></i>{' '}
            <i className="bi bi-trash" onClick={() => handleDeleteEmployeee(item.id)} style={{ fontSize: "21px", color: "rgb(175, 2, 2)" }}></i>
          </td>
        </tr>
      ))
   ) : (
    <tr>
      <td colSpan="6" style={{ textAlign: "center", color:"red", fontWeight:"bold", borderColor:"black" }}>
       No Blocked slot found
      </td>
    </tr>
   )}
 

   </tbody>
}
</table>
<Pagination
        activePage={currentPage}
        itemsCountPerPage={itemsPerPage}
        totalItemsCount={totalItems}
        pageRangeDisplayed={5}
        onChange={handlePageChange}
        itemClass="page-item"
        linkClass="page-link"
        innerClass="pagination justify-content-end"
        activeClass="active-pagination"
      />
      </div>
      

</div>
        </div>
      
      </div>

      <Modal
        show={show}
        onHide={()=>setShow(false)}
        backdrop="static"
        keyboard={false}
        size="md" // Set size to large
      >
        <Modal.Header style={{padding:"3px", backgroundColor:"green"}}>
          <Modal.Title style={{ fontSize:"20px"}}></Modal.Title>
        </Modal.Header>
        <Modal.Body>

         <div style={{padding:"20px"}}>
         {/* <h4 style={{fontFamily:"monospace",fontWeight:"bolder",textAlign:"center"}}>CONFIRM !</h4> */}
          <h6 className='text-dark' style={{textAlign:"center",fontWeight:"bolder"}}>Are You Sure want to Delete Supplier Name 
          <span style={{color:"red",textTransform:"uppercase"}}> </span> ?</h6> 
         </div>
         {' '} 
          <Button variant="danger" style={{float:"right"}} onClick={()=>setShow(false)}>
            Close
          </Button>{' '} 
          <Button variant="success" style={{float:"right",marginRight:"5px"}} onClick={handleDelete}>
            Confirm
          </Button>
        </Modal.Body>
        {/* <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseConfirmation}>
            Close
          </Button>
        </Modal.Footer> */}
      </Modal>

      <Modal
        show={isEdit}
        onHide={()=>setIsEdit(false)}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title> Update Blocked Slot</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <form  className="py-2" onSubmit={handleUpdateSubmit}>
          <div class="row">
            <div class="col">
               <label for="input1" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Select Date</label>
               <input
  type="date"
  className="form-control"
  placeholder="Enter Select Date"
  id="blocked_date"
  value={(updateformData.blocked_date)} // Convert date for display
  name="blocked_date"
  onChange={handleInputUpdateChange} // Update state with reversed format
  style={{ borderRadius: "12px" }}
  required
/>
            </div>
            <div className="col">
  <label
    htmlFor="slotSelect"
    style={{ color: "green", fontFamily: "serif", fontWeight: "bolder" }}
  >
    Select Slot
  </label>
  <Select
        className="form-control"
        name="table_no"
        onChange={handleSupplierSelectChanges}
        options={tables.map((table) => ({
          value: table.id,
          label: table.slot_name,
        }))}
         value={
    updateformData.slot_id
      ? { value: updateformData.slot_id, label: updateformData.slot_name }
      : null
  }
        placeholder="Select Supplier"
        isSearchable={true}
      />

</div>

          </div>
          <br/>
          <div class="row">
            <div class="col">
            <label for="input5" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Enter Remarks{" "}</label>
              <input type="text" class="form-control" id="formFile" value={updateformData.remarks}  name='remarks' placeholder='Enter Remarks' style={{borderRadius:"12px"}} onChange={handleInputUpdateChange} />
            </div>
            <div class='col'></div>
          </div>
          {/* <div class="row">
            <div class="col">
          <div class="card mb-3" style={{width: "22rem",height:"10rem",borderRadius:"15px",border:"none",overflowX:"scroll",float:"left",zIndex:"1"}}>
                          <div class="card-body">
                            <h5 class="card-title" style={{fontSize:"14px",color:"green"}}>Select Shop</h5>
                            {updateformData.shops.map((shop, index) => (
        <div className="form-check" key={index}>
          <input
            className="form-check-input"
            type="checkbox"
            value=""
            id={`flexCheckDefaultupdate_${index}`}
            onChange={() => handleUpdateCheckboxChange(index)}
            checked={shop.is_active === 1}
          />
          <label className="form-check-label" htmlFor={`flexCheckDefaultupdate_${index}`}>{shop.shop_name}</label>
        </div>
      ))}   
                           
                          </div>
                         </div>
       </div>
       <div class="col">
       </div> 
       </div> */}
         <br/>
          <button className="btn btn-success" style={{float:"right",margin:"5px",borderRadius:"15px"}}>Update</button>
          </form>
          <button className="btn btn-danger" onClick={()=>setIsEdit(false)} style={{borderRadius:"15px",float:"right",marginTop:"-1px"}}>Cancel</button>
        </Modal.Body>
      </Modal> 

      <Modal
        show={isCreate}
        onHide={()=>setCreate(false)}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title> Create Blocked Slot</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <form  className="py-2" onSubmit={Submit}>
          <div class="row">
            <div class="col">
               <label for="input1" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Select Date</label>
               <input
          type="date"
          className="form-control"
          id="floatingInput"
          placeholder="Select Date"
          name="blocked_date"
          value={formData.blocked_date} // Ensure consistent display
          onChange={handleInputChange}
          style={{ borderRadius: "15px", height: "50px" }}
          required
        />               </div>
               <div className="col">
  <label
    htmlFor="slotSelect"
    style={{ color: "green", fontFamily: "serif", fontWeight: "bolder" }}
  >
    Select Slot
  </label>
  <Select
        className="form-control"
        name="table_no"
        value={selectedSupplier}
        onChange={handleSupplierSelectChange}
        options={tables.map((supplier) => ({
          value: supplier.id,
          label: supplier.slot_name,
        }))}
        placeholder="Select Slot"
        isSearchable={true}
      />
</div>

          </div>
          <br/>
          <div class="row">
            <div class="col">
            <label for="input5" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Enter Remarks{" "}</label>
            <input type="text" class="form-control" id="formFile" placeholder='Enter Remarks'  name='remarks'  value={formData.remarks} onChange={handleInputChange} style={{borderRadius:"15px",height:"50px"}} />
            </div>
            <div class='col'></div>
          </div>
        
         <br/>
         <div class="text-center">
          {postloading ? (
          <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
           
          />
        ) : (
          <button className='btn btn-success' style={{borderRadius:"15px",float:"right",marginTop:"6px"}} disabled={postloading}>Create</button>
        )}
        </div>           </form>
          <button className="btn btn-danger" onClick={()=>setCreate(false)} style={{borderRadius:"15px",float:"right",marginRight:"5px"}}>Cancel</button>
        </Modal.Body>
      </Modal> 


            {/* </div> */}
       </Layout></>

        
    )
}

export default CreateBlockingPublicHoliday;